import { pick } from "@t3tools/shared/i18n";

// Its own two strings rather than the app catalogs: the boot entry stays free
// of every screen's text, which loads with the app chunks this page reports on.
const TEXT = {
  en: { failed: "zwrm Cowork could not load.", reload: "Reload" },
  de: { failed: "zwrm Cowork konnte nicht geladen werden.", reload: "Neu laden" },
};

/** Shows startup failures before React can replace the boot splash. */
export function showBootError(error: unknown) {
  console.error("zwrm Cowork failed to start.", error);
  const bootShell = document.getElementById("boot-shell");
  if (!bootShell) return;
  const text = pick(TEXT);

  const content = document.createElement("div");
  content.id = "boot-error";
  content.setAttribute("role", "alert");

  const message = document.createElement("p");
  message.textContent = text.failed;
  content.append(message);

  if (import.meta.env.DEV && error instanceof Error) {
    const detail = document.createElement("p");
    detail.textContent = error.message;
    content.append(detail);
  }

  const reload = document.createElement("button");
  reload.type = "button";
  reload.textContent = text.reload;
  reload.addEventListener("click", () => window.location.reload());
  content.append(reload);
  bootShell.replaceChildren(content);
}
